module.exports = __webpack_public_path__ + "static/media/3DPPA16.83f2a2f9.jpg";